import { post } from '../http/api';

// Every entry point uses the same response handling. A blocked action must
// never appear as a successful request or remove a suggested profile.
export async function requestMatch(userId) {
  try {
    const result = await post(`matches/like/${userId}`);
    window.dispatchEvent(new CustomEvent('carrerup:matching-usage', { detail: result.data?.usage }));
    return result;
  } catch (error) {
    const notices = { PREMIUM_REQUIRED: '', MATCH_REQUEST_LIMIT_REACHED: 'requests', MATCH_LIMIT_REACHED: 'matches', MATCH_UNAVAILABLE: 'unavailable', MATCH_TARGET_LIMIT_REACHED: 'targetLimit', MATCHING_SETUP_REQUIRED: 'setup' };
    if (Object.prototype.hasOwnProperty.call(notices, error.message)) {
      window.dispatchEvent(new CustomEvent('carrerup:premium-matching', { detail: { notice: notices[error.message] } }));
      return null;
    }
    throw error;
  }
}
